var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 36,
    viewBox: "0 0 66 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 24.6663H9.99992C13.3333 24.6663 14.6666 23.333 14.6666 19.9997V15.9997C14.6666 12.6663 13.3333 11.333 9.99992 11.333H5.99992C2.66659 11.333 1.33325 12.6663 1.33325 15.9997V19.9997C1.33325 23.333 2.66659 24.6663 5.99992 24.6663Z",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0025 20.2531H6.72252C5.58919 20.2531 4.66919 19.3332 4.66919 18.1998C4.66919 17.0665 5.58919 16.1465 6.72252 16.1465H11.2359",
    stroke: "#004EFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2891 17.1801L11.3357 16.1267L10.2891 15.0801",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4844 13.0059C29.3457 13.0059 30.0566 13.1107 30.6172 13.3203C31.1823 13.5299 31.6016 13.849 31.875 14.2773C32.153 14.7057 32.292 15.2503 32.292 15.9111C32.292 16.4033 32.2008 16.8226 32.0186 17.1689C31.8363 17.5153 31.597 17.8024 31.3008 18.0303C31.0046 18.2581 30.6878 18.4404 30.3506 18.5771L33.1875 23H31.335L28.9219 18.9941H27.3154V23H25.6748V13.0059H28.4844ZM28.375 14.373H27.3154V17.6406H28.4502C29.2113 17.6406 29.7627 17.4993 30.1045 17.2168C30.4508 16.9342 30.624 16.5173 30.624 15.9658C30.624 15.387 30.4395 14.9769 30.0703 14.7354C29.7057 14.4938 29.1406 14.373 28.375 14.373ZM40.2764 23H34.6162V13.0059H40.2764V14.3867H36.2568V17.1006H40.0234V18.4746H36.2568V21.6123H40.2764V23ZM45.3418 13.0059C46.6315 13.0059 47.5726 13.2702 48.165 13.7988C48.7575 14.3275 49.0537 15.068 49.0537 16.0205C49.0537 16.4535 48.9854 16.8659 48.8486 17.2578C48.7165 17.6452 48.4977 17.9893 48.1924 18.29C47.887 18.5863 47.4837 18.821 46.9824 18.9941C46.4857 19.1673 45.8727 19.2539 45.1436 19.2539H44.0771V23H42.4365V13.0059H45.3418ZM45.2324 14.3662H44.0771V17.8867H44.9727C45.4876 17.8867 45.9251 17.8275 46.2852 17.709C46.6452 17.5859 46.9186 17.3923 47.1055 17.1279C47.2923 16.8636 47.3857 16.515 47.3857 16.082C47.3857 15.5033 47.2103 15.0726 46.8594 14.79C46.513 14.5075 45.9707 14.3662 45.2324 14.3662ZM51.0498 23V13.0059H52.6904V21.6055H56.9355V23H51.0498ZM61.4951 17.5654L63.8672 13.0059H65.6377L62.3154 19.1172V23H60.6816V19.1787L57.3525 13.0059H59.1367L61.4951 17.5654Z",
    fill: "#004EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/Reply.2ded398ea5065ef4984b520885eb5173.svg";
export { ForwardRef as ReactComponent };